<template>
  <page-template type="rightpanel">
    <template v-slot:toolbar>
      <tool-bar type="back-arrow" :title="operation.title ? operation.title : 'Nouvelle Opération'" linkback="/operations"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div>
          <v-form class="form-new-element">
            <v-container>
              <v-select v-model="operation.category" :disabled="opening" :items="operationCategory" item-text="name" item-value="_id" label="Opération du moment" outlined></v-select>
              <v-text-field v-model="operation.title" :disabled="opening" label="Titre de l'opération" outlined></v-text-field>
              <v-text-field v-model="operation.description" :disabled="opening" label="Descriptif de l'opération" outlined></v-text-field>
              <v-select v-model="operation.owners" :disabled="opening" :items="recipients" item-text="name" item-value="_id" label="Choisir les destinataires" multiple chips deletable-chips outlined></v-select>
              <div class="add-file">
                <v-file-input v-model="newImages" v-if="!opening === true" type="file" @change="uploadImages()" multiple placeholder="Ajouter un document" outlined dense prepend-icon=""></v-file-input>
                <div v-for="(image, index) in images" :key="image.id" class="added-file">
                    <v-icon v-if="!opening === true" @click="deleteImage(index)" >mdi-close</v-icon>
                    <img :src="image.link" alt="">
                </div>
              </div>
              <div v-if="!opening === true" class="d-flex justify-center">
                  <v-btn class="mt-4 mx-4 primary-button outlined" @click="save(false)">Enregistrer</v-btn>
                  <v-btn class="mt-4 mx-4 primary-button" @click="save(true)">Publier</v-btn>
              </div>
            </v-container>
          </v-form>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <guide-creation
        title="Aide a la création d’opération"
        text="Le titre doit être court soyez précis sur le descriptif Les documents importés doivent être au format pdf, jpg ou png avec un poid inférieur à 2 Mo"
      ></guide-creation>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import guideCreation from '@/components/GuideCreation.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'OperationsNew',
    components: { pageTemplate, toolBar, guideCreation },
    props: {
      editing: {
        type: Boolean,
        default: false
      },
      opening: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        newImages: [],
        operationCategory: [],
        recipients: [],
        images: [],
        operation: {
          title: '',
          description: '',
          category: '',
          owners: '',
          images: [],
          activated: false
        }
      }
    },
    async created () {
      try {
         // GET OPERATION CATEGORIES
        const operationCategoriesRes = await axios.get(`${apiURL}/data/operation/categories`)
        this.operationCategory = operationCategoriesRes.data.model
        // GET LIST OF RECIPIENTS
        const RecipientsRes = await axios.get(`${apiURL}/data/apartments`)
        this.recipients = RecipientsRes.data.model
        // EDITING OR OPENING - GET OPERATION INFORMATION
        if (this.editing || this.opening) {
          const operationRes = await axios.get(`${apiURL}/manage/operation/${this.$route.params.id}`)
          this.operation = operationRes.data.model
          this.operation.id = this.operation._id
          this.operation.images.forEach(e => {
            this.images.push({ id: e, link: `${apiURL}/files/render/image/${e}` })
          })
        }
      } catch (e) {
      }
    },
    methods: {
      // SUBMIT IMAGE
      async uploadImages () {
          if (!this.newImages.length) return
          try {
              console.log('images to upload', this.newImages)
              this.$store.dispatch('loading')
              const formData = new FormData()
              for (let i = 0; i < this.newImages.length; i++) {
                  formData.append('images', this.newImages[i])
              }
              const imageRes = await axios.post(`${apiURL}/files/upload/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              imageRes.data.model.ids.forEach(e => {
                  this.images.push({ id: e, link: `${apiURL}/files/render/image/${e}` })
              })
          } catch (e) {
              alert('Une erreur est survenue, veuillez réessayer.')
              console.log(e)
          } finally {
              this.newImages = []
              this.$store.dispatch('stop_loading')
          }
      },
      // DELETE IMAGE
      deleteImage (index) {
          this.images.splice(index, 1)
      },
      // DRAFT, PUBLISH OR EDIT NEW OPERATION
      async save (isDraft, redirect = true) {
          this.$store.dispatch('loading')
          try {
              this.operation.images = this.images.map(e => { return e.id })
              this.operation.activated = isDraft
              if (!this.editing) {
                await axios.post(`${apiURL}/manage/operation`, this.operation)
              } else {
                await axios.put(`${apiURL}/manage/operation/`, this.operation)
              }
              if (redirect) {
                this.$router.push('/operations')
              }
          } catch (e) {
              alert('Une erreur est survenue, veuillez réessayer.')
              console.log(e)
          } finally {
              this.$store.dispatch('stop_loading')
          }
      }
    }
  }
</script>